export default __webpack_public_path__ + "f2110ef4825cac25ec4e86a02b13acee.svg";